import Vuex from 'vuex';
import Vue from 'vue';
import { PAGE } from '../enums';
import wochitLogo from '../img/wochit-vector-logo-blue.svg';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    serverProfile: serverProfile,
    isPending: true,
    page: PAGE.NONE,
    resetKey: new URLSearchParams(window.location.search).get('key'),
    login: false,
  },

  mutations: {
    FETCHING(state) {
      state.isPending = true;
    },
    CHANGE_PAGE(state, page) {
      state.page = page;
    },
    FETCH(state) {
      state.isPending = false;
    },
    IS_LOGIN(state, isLogin) {
      state.login = isLogin;
    },
  },

  getters: {
    // We can ignore Org-ID on login
    headers: ({ serverProfile }) =>
      serverProfile.channelId ? { 'Channel-ID': serverProfile.channelId } : {},
    apiUrl: ({ serverProfile }) => serverProfile.apiUrl,
    authUrl: ({ serverProfile }) => serverProfile.authUrl,
    isPending: ({ isPending }) => isPending,
    isLogin: ({ login }) => login,
    isResetPassword: ({ resetKey }) => Boolean(resetKey),
    wochitLogo: () => wochitLogo,
    channelLogo: ({ serverProfile }) =>
      serverProfile.channelLogoUrl ? serverProfile.channelLogoUrl : wochitLogo,
    page: ({ page }) => page,
  },

  actions: {
    login({ getters, commit }, { email, password }) {
      commit('FETCHING');
      return fetch(`${getters.authUrl}/api/v1/login`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...getters.headers,
        },
        body: JSON.stringify({
          email,
          password,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          const isLogin = Boolean(res.token);
          commit('IS_LOGIN', isLogin);
          if (isLogin) {
            const url = new URL(window.location);
            const redirect = url.searchParams.get('redirectUrl');
            document.cookie = `signup_email=${email};path=/;domain=.wochit.com;max-age=31536000;secure;samesite=lax`;
            window.location = redirect || '/';
          }
          return res;
        })
        .finally(() => commit('FETCH'));
    },

    forgot({ state, getters, commit }, { email }) {
      commit('FETCHING');
      return fetch(`${getters.authUrl}/api/v1/userCredentials/password/reset`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          channelId: state.serverProfile.channelId || '1',
          email,
        }),
      })
        .then((res) => {
          if (200 === res.status) {
            commit('CHANGE_PAGE', PAGE.FORGOT_SEND);
          }
        })
        .finally(() => commit('FETCH'));
    },

    resetPassword({ commit, state, getters }, { password }) {
      commit('FETCHING');
      return fetch(`${getters.authUrl}/api/v1/userCredentials/password`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          resetPasswordKey: state.resetKey,
          password: password,
        }),
      })
        .then((res) => {
          if (200 === res.status) {
            commit('CHANGE_PAGE', PAGE.RESET_PASSWORD_DONE);
          }
        })
        .finally(() => commit('FETCH'));
    },

    checkStatus({ getters, commit }) {
      commit('FETCHING');
      fetch(`${getters.apiUrl}/api/v1/users/me/minimized`, {
        method: 'GET',
        credentials: 'include',
        headers: getters.headers,
      })
        .then((res) => {
          commit('IS_LOGIN', 200 === res.status);
          commit(
            'CHANGE_PAGE',
            getters.isResetPassword ? PAGE.RESET_PASSWORD : PAGE.LOGIN
          );
        })
        .finally(() => commit('FETCH'));
    },
  },
});

export default store;
